import { DateFilter, ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { MetalDetectionResponse } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import appSettings from 'apps/services/config';
import { Between, getManager, LessThanOrEqual, MoreThan, Raw } from 'typeorm';
import { MetalDetectionDto } from './dto/metal-detection.dto';
import { MetalDetectionRepository } from './metal-detection.repository';
const moment = require('moment');
@Injectable()
export class MetalDetectionService {
    constructor(private repo: MetalDetectionRepository) { }

    async createMetalDetectionLog(data: MetalDetectionDto): Promise<CommonResponse> {
        try {
            const saveResponse = await this.repo.save(data);

            if (saveResponse) {
                return new CommonResponse(true, 1111, 'Logged Successfully')
            } else {
                throw new ErrorResponse(9999, 'Failed to Save')
            }
        } catch (error) {
            return error;
        }

    }

    async getMetalDetectionLog(date: DateFilter): Promise<MetalDetectionResponse> {
        try {
            const fromDate = moment(date.fromDate).format("YYYY-MM-DD 00:00:00");
            const toDate = moment(date.toDate).format("YYYY-MM-DD 00:00:00");

            const manager = getManager();
            const query = `SELECT m.m_detection_id as metalDetectionId, m.date, m.min_grade as minGrade, m.max_grade as maxGrade, m.variety, m.brand, m.s_code sCode, m.operation, m.mm_fe as mmFe, m.mm_non_fe as mmNonFe, mm_ss as mmSS, min_pouches as minPouches, max_pouches as maxPouches, metal_detected as metalDetected, m.corrective_action as correctiveAction, m.plant, m.created_user as createdUser, m.updated_user as  updatedUser, iib.brand_name as brandName,v.variant_code as varietyName
                 FROM `+ appSettings.production_db + `.metal_detection m 
                 LEFT JOIN `+ appSettings.masters_db + `.master_brands iib ON iib.master_brand_id = m.brand
                 LEFT JOIN `+ appSettings.masters_db + `.sku_codes v ON v.sku_code_id = m.variety
                 where Date(date) between '${fromDate}' and '${toDate}' 
                 order by  m.date desc`;
            const dataResponse = await manager.query(query);
            if (dataResponse?.length) {
                return new MetalDetectionResponse(true, 1111, `Metal Detection Log between ${moment(date.fromDate).format("YYYY-MM-DD")} and ${moment(date.toDate).format("YYYY-MM-DD")}`, dataResponse);
            } else {
                return new MetalDetectionResponse(false, 99999, `Metal Detection Log Not Found between ${moment(date.fromDate).format("YYYY-MM-DD")} and ${moment(date.toDate).format("YYYY-MM-DD")}`, dataResponse);
            }
        } catch (error) {
            return error;
        }
    }
}


